import { createContext, useContext, useState, useEffect } from 'react';
import { translations as base } from './translations';
import { pageTranslations } from './pageTranslations';
import { extranetTranslations } from './extranetTranslations';
import { mandateTranslations } from './mandateTranslations';

// Merge page translations into base
const translations = {
  fr: { ...base.fr, ...pageTranslations.fr, ...extranetTranslations.fr, ...mandateTranslations.fr },
  en: { ...base.en, ...pageTranslations.en, ...extranetTranslations.en, ...mandateTranslations.en },
  zh: { ...base.zh, ...pageTranslations.zh, ...extranetTranslations.zh, ...mandateTranslations.zh },
};

const LanguageContext = createContext(null);

const SUPPORTED = ['fr', 'en', 'zh'];

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = typeof window !== 'undefined' ? localStorage.getItem('yuville_lang') : null;
    return SUPPORTED.includes(saved) ? saved : 'fr';
  });

  const setLang = (l) => {
    if (!SUPPORTED.includes(l)) return;
    setLangState(l);
    localStorage.setItem('yuville_lang', l);
    document.documentElement.lang = l;
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (path) => {
    const parts = path.split('.');
    let obj = translations[lang];
    for (const p of parts) {
      obj = obj?.[p];
      if (obj === undefined) break;
    }
    if (obj === undefined) {
      // fallback to French
      let fb = translations.fr;
      for (const p of parts) fb = fb?.[p];
      return fb ?? path;
    }
    return obj;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLang must be used inside LanguageProvider');
  return ctx;
}

export const LANG_LABELS = {
  fr: { code: 'FR', name: 'Français' },
  en: { code: 'EN', name: 'English' },
  zh: { code: '中文', name: '中文' },
};
